<script setup>
import TableHelper from "@/components/Tools/TableHelper/TableHelper.vue";
import { computed, onMounted, ref, watch } from "vue";
import Reporting from "@/components/Workflows/Reporting/reporting";
import { Error } from "@/core/plugins/swal";
import i18n from "@/core/plugins/vue-i18n";
import { useStore } from "@/core/services/store";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";
import { useArticleImport } from "@/components/ExternalApps/SalesChannelManagementApp/composables/useArticleImport";
import { useUtility } from "@/components/ExternalApps/SalesChannelManagementApp/composables/useUtility";
import { useIntegration } from "@/components/ExternalApps/SalesChannelManagementApp/composables/useIntegration";

const store = useStore();
const { isFinished } = useArticleImport();
const { xentralProjectHeader } = useUtility();
const { selectedIntegration } = useIntegration();

const BUILD_FL_WORKFLOW_ID = computed(() => store.getters.buildFlWorkflowId);

const stoppedIterations = ref([]);

const meta = ref({});
const fields = ref([
  {
    key: "case_identifier",
    label: i18n.t("salesChannelManagementApp.articleCount"),
    sortable: true
  },
  {
    key: "finished_at",
    label: i18n.t("salesChannelManagementApp.date"),
    sortable: true,
    type: "datetime"
  }
]);

const channelSpecificName = computed(
  () =>
    selectedIntegration?.value?.name
      ?.replace(store.getters.selectedApp.name, "")
      .trim() ?? ""
);

function getAllFinishedIterations() {
  const requestParams = {
    filter: [
      {
        key: "status",
        op: "equals",
        value: "process.stopped"
      },
      {
        key: "content_identifier",
        op: "in",
        value: [
          channelSpecificName.value + " Finished",
          channelSpecificName.value + "\u00A0Finished"
        ]
      }
    ]
  };

  addEventToLoadingQueue({ key: "loadJobs" });

  const header = !store.getters.useXentralProjectForSync
    ? {}
    : xentralProjectHeader.value;

  Reporting.getIterations(
    BUILD_FL_WORKFLOW_ID.value,
    requestParams,
    header,
    true
  )
    .then(response => {
      meta.value = response.meta;
      stoppedIterations.value = response.data;
    })
    .catch(error => Error(error))
    .finally(() => {
      removeEventFromLoadingQueue({ key: "loadJobs" });
    });
}

watch(
  () => isFinished.value,
  () => getAllFinishedIterations()
);

onMounted(() => {
  getAllFinishedIterations();
});
</script>

<template>
  <div>
    <TableHelper
      :fields="fields"
      :items="stoppedIterations"
      :meta="meta"
      disable-search
      disable-skeleton-loading
      loading-key="loadJobs"
      :title="$t('salesChannelManagementApp.usedFilters')"
      @reload-data="getAllFinishedIterations"
    />
  </div>
</template>

<style lang="scss" scoped></style>
